import React from "react";
import { DatasetInfo as DatasetInfoModel } from "api/model/dataset/DatasetInfo";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { TagSpan } from "./Tags";

const DatasetsList = ({
  isSuccessByTags,
  dataByTags,
  selectedDataset,
  setSelectedDataset,
}: {
  isSuccessByTags: boolean;
  dataByTags: DatasetInfoModel[];
  selectedDataset: DatasetInfoModel | null;
  setSelectedDataset: (e: DatasetInfoModel) => void;
}) => {
  const tagsBodyTemplate = (rowData: DatasetInfoModel) => {
    return (
      <div className="col-9 w-12 flex gap-1 flex-wrap">
        {rowData.tags.map((t: string) => (
          <TagSpan tag={t} key={t} />
        ))}
      </div>
    );
  };

  return (
    <div>
      {isSuccessByTags && dataByTags?.length > 0 && (
        <DataTable
          size="small"
          value={dataByTags}
          scrollable
          scrollHeight="200px"
          dataKey="identifier"
          selectionMode="single"
          selection={selectedDataset}
          onSelectionChange={e => setSelectedDataset(e.value)}
        >
          <Column field="title" header="Title" style={{ width: "50%" }} />
          <Column field="tags" header="Tags" body={tagsBodyTemplate} style={{ width: "50%" }} />
        </DataTable>
      )}
    </div>
  );
};

export default DatasetsList;
